import script from "./MyDropdownCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./MyDropdownCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./MyDropdownCheckbox.vue?vue&type=style&index=0&id=77eb3dce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77eb3dce"]])

export default __exports__